<template>
  <transition name="el-fade-in-linear">
    <div v-show="dialogVisible" class="popContainer indiv-pop">
      <div class="indiv-pop-center">
        <span
          class="indiv-pop-close iconfont icon-close_round_fill_bold"
          role="button"
          aria-label="关闭"
          @click="onClose"
        ></span>
        <div class="indiv-pop-box agreement-pop">
          <h3 class="hd">软件服务协议</h3>
          <div class="body">
            <div class="agreement-content indiv-scrollbar">
              <p>
                <b>&emsp;&emsp;用户使用武汉杰宜斯信息科技有限公司（以下简称"杰宜斯科技"）提供的"杰宜斯软件"服务前，请务必仔细阅读并确认本协议。用户在本电子协议签约页面勾选"我已阅读并确认本协议，接受本协议项下所述全部条款"并点击"确定"后，即视为用户签署本协议接受本协议项下所述全部条款。</b><br /><br />
                <b>&emsp;&emsp;协议经双方确认后即行生效，协议内容将对用户及杰宜斯科技双方产生法律约束力。因此，杰宜斯科技提醒用户在确认本协议之前，应当认真阅读并理解本协议项下全部条款。</b><br /><br />

                <b class="sec">一、 软件服务内容</b><br /><br />
                &emsp;&emsp;<b class="no">1.1</b
                >用户同意向杰宜斯科技购买，杰宜斯科技同意向用户销售本协议约定的软件服务，本软件提供的服务主要用于解决投资机构在期货业务中遇到的：实现多个账户同时进行开平操作，并对账户设定不同比例进行下单的需求。<br /><br />
                &emsp;&emsp;<b class="no">1.2</b
                >杰宜斯科技采用电话、网络解答等多种方式向用户提供软件服务，包括软件的技术操作培训和使用指导，并协助用户及时解决用户使用软件过程中出现的相关问题。<br /><br />
                &emsp;&emsp;<b class="no">1.3</b
                >杰宜斯科技根据对软件的改进，免费为用户提供软件现有功能的升级服务。<br /><br />

                <b class="sec">二、 双方的权利和义务</b><br /><br />
                <b>用户的权利和义务</b><br /><br />
                &emsp;&emsp;<b class="no">2.1</b
                >用户应尊重杰宜斯科技的软件著作权和相关知识产权，未经杰宜斯科技的书面许可，不得对杰宜斯科技软件进行复制、传播，也不得对软件进行反向工程（Reverse
                Engineering）、反编译(Decompiling)或反汇编(Disassembling)。<br /><br />
                &emsp;&emsp;<b class="no">2.2</b
                >杰宜斯科技提供的软件及服务仅限于用户自行使用。用户不得向任何第三方有偿或无偿转让或提供按本协议约定所享有的软件服务权益。<br /><br />
                &emsp;&emsp;<b class="no">2.3</b
                >用户应按照杰宜斯科技要求，为杰宜斯科技软件运行提供应用环境，软件安装、运行必须的场地、软硬件（包括服务器及操作系统）、电源、互联网接入，以及相关资源，保证软件安装、运行的正常进行。<br /><br />
                &emsp;&emsp;<b class="no">2.4</b
                >用户负责保护登录账号和密码的安全，杰宜斯科技提供协议内约定的软件服务客户端软件，严禁用户进行破解，因用户原因导致账号或密码不能正常使用的，用户自行承担责任。<br /><br />
                &emsp;&emsp;<b class="no">2.5</b
                >杰宜斯软件的日常运维由用户自行完成。<br /><br />
                &emsp;&emsp;<b class="no">2.6</b
                >用户应按照本协议约定的时间和金额及时向杰宜斯科技支付软件服务费用。<br /><br />
                &emsp;&emsp;<b class="no">2.7</b
                >用户应为杰宜斯科技进行软件安装和升级提供必要的协助和配合。<br /><br />
                &emsp;&emsp;<b class="no">2.8</b
                >用户有权要求杰宜斯科技通过电话、网络解答等多种方式提供软件的技术操作培训和使用指导。<br /><br />
                &emsp;&emsp;<b class="no">2.9</b
                >基于杰宜斯科技提供的是通用软件服务，用户如需杰宜斯科技提供新增需求服务，除待杰宜斯科技日后提供免费的升级服务之外，可与杰宜斯科技友好协商另行签订协议。<br /><br />
                &emsp;&emsp;<b class="no">2.10</b
                >用户承诺其使用本软件之目的及场景符合中国证监会、期货业协会等相关监管规定，具备合法使用本软件的主体资质。因用户违规使用导致的监管处罚或第三方索赔，由用户自行承担，杰宜斯不承担责任。<br /><br />
                &emsp;&emsp;<b class="no">2.11</b
                >用户应严格遵守国家法律法规和政策规定，不得利用杰宜斯科技软件及服务进行任何违反或可能违反我国法律法规及政策的活动。杰宜斯科技对于用户使用杰宜斯科技软件或服务进行违法违规活动的后果不承担任何责任，且杰宜斯科技有权解除本协议，停止为用户提供协议约定的软件服务并不退还软件服务费用。杰宜斯有权配合监管部门调查并提供必要日志信息。<br /><br />
                &emsp;&emsp;<b class="no">2.12</b
                >若用户在本协议约定期限前未与杰宜斯科技书面续约或重新签订新的软件服务协议，则导致协议到期后软件不能正常使用，杰宜斯科技不承担任何责任。<br /><br />
                <b>杰宜斯科技的权利和义务：</b><br /><br />
                &emsp;&emsp;<b class="no">2.13</b
                >杰宜斯科技完全拥有软件的所有权、著作权及一切与之相关的知识产权和财产权利。杰宜斯科技保证提供给用户使用的软件拥有独立的知识产权，并有权提供相关软件服务，如因此给用户造成实际损失，杰宜斯科技承担相应的赔偿责任。<br /><br />
                &emsp;&emsp;<b class="no">2.14</b
                >服务期限内，杰宜斯科技按照协议约定为用户提供优质高效的软件服务。<br /><br />

                <b class="sec">三、 服务期限、费用及结算</b><br /><br />
                &emsp;&emsp;<b class="no">3.1</b
                >服务期限：服务期限为壹年，自本协议生效次日起算。<br /><br />
                &emsp;&emsp;<b class="no">3.2</b>软件服务费用：人民币 9,888
                元/年/个（大写：玖仟捌佰捌拾捌元整/年/个 ）。<br /><br />

                <b class="sec">四、 免责条款</b><br /><br />
                &emsp;&emsp;<b class="no">4.1</b
                >由于软件系统开发本身的复杂性，无法保证软件完全没有错误。杰宜斯科技（其中包括但不限于杰宜斯科技公司的股东、董事、管理人员、员工、顾问和代理商等）明确拒绝对所提供的所有软件做任何明示或暗示的瑕疵担保。用户选择使用杰宜斯科技软件即表示接受错误和/或遗漏的存在，在任何情况下杰宜斯科技对于直接、间接、特殊的、偶然的、或间接引发的使用或无法使用本软件进行交易和投资造成的盈亏、直接或间接引起的赔偿、损失、债务或是任何交易中止等均不承担责任和义务。但因杰宜斯科技故意造成的除外。<br /><br />
                &emsp;&emsp;<b class="no">4.2</b
                >若因国家法律法规、政策的变化调整，或行政机关或行业主管部门的要求，造成杰宜斯科技不能继续为用户提供本协议项下软件服务，由此造成的用户损失，杰宜斯科技不承担赔偿责任。<br /><br />

                <b class="sec">五、 保密条款</b><br /><br />
                &emsp;&emsp;<b class="no">5.1</b
                >一方未经另一方书面同意，不得向任何第三方披露本协议的任何条款和内容。<br /><br />
                &emsp;&emsp;<b class="no">5.2</b
                >一方未经另一方书面同意，不得向任何第三方披露与本协议有关的商业秘密，除非有对方的书面许可，或该信息已被拥有方认为不再是商业秘密，或已在社会上公开，该商业秘密应当在10年内不得对外披露。本协议项下之商业秘密系指一方所拥有或持有、不为外界所知、根据本协议约定向另一方披露，并由披露方采取了保密措施的所有技术及商业信息，包括但不限于软件规格、设计、外观、专有技术、数据、公式、程序、照片、图片、软件程序及样品、知识产权、商业计划、业务或制度、财务和交易状况；客户、供应商、债权人或债务人的资料，与披露方管理人员、董事或雇员有关的信息；营销信息、宣传册、印刷品、价格、价目表及协议等。<br /><br />

                <b class="sec">六、 违约责任</b><br /><br />
                &emsp;&emsp;<b class="no">6.1</b
                >用户及杰宜斯科技均应严格执行本协议条款，确保本协议的顺利履行。<br /><br />
                &emsp;&emsp;<b class="no">6.2</b
                >除本协议另有约定之外，任何一方违反本协议项下任何一项约定而造成另一方经济损失的，违约方应按照守约方直接经济损失的金额向守约方支付违约金。违约方支付的违约金总额不超过本协议总金额的百分之二十。<br /><br />
                &emsp;&emsp;<b class="no">6.3</b
                >任何一方违反本协议所约定的保密义务，违约方应按本协议约定的软件服务费总金额的壹倍支付违约金。如包括利润在内的实际损失超过该违约金的，受损失一方有权要求对方赔偿超过部分。<br /><br />
                &emsp;&emsp;<b class="no">6.4</b
                >若政府部门认定用户利用杰宜斯科技软件及服务实施违反国家法律法规或政策的行为，则杰宜斯科技有权立即终止提供本协议项下的软件服务，且已收取的软件服务费不予退还。若因用户的违法行为造成杰宜斯科技损失的，杰宜斯科技有权要求用户赔偿。<br /><br />
                &emsp;&emsp;<b class="no">6.5</b
                >若用户违反本协议第二条第2.1项约定，无论是否造成杰宜斯科技经济损失，用户均应当按照本协议约定的软件服务费总金额的拾倍向杰宜斯科技支付违约金。如包括利润在内的实际损失超过该违约金的，杰宜斯科技有权要求对方赔偿差额部分。<br /><br />
                &emsp;&emsp;<b class="no">6.6</b
                >如发生违约事件，守约方要求违约方支付违约金时，应以书面方式通知违约方，内容包括违约事件、违约金、支付时间和方式等。违约方在收到上述通知后，应于两天内答复对方，并支付违约金。如双方不能就此达成一致意见，将按照本协议所规定的争议解决条款解决双方的纠纷，但任何一方不得采取非法手段或以损害本软件的方式实现违约金。<br /><br />

                <b class="sec">七、 争议解决</b><br /><br />
                &emsp;&emsp;如果协议双方在履行本协议过程中发生争议，双方应首先采取友好协商的方式解决该争议。如协商不成的，任何一方可向武汉市武昌区人民法院提起诉讼。<br /><br />

                <b class="sec">八、 通知</b><br /><br />
                &emsp;&emsp;<b class="no">8.1</b
                >一方通知另一方时，通知方应采取书面形式，以快递或以专人送达或电子邮件的方式送达被通知方在本协议中确定的联系人、地址、电子邮箱送达视为生效。<br /><br />
                &emsp;&emsp;<b class="no">8.2</b
                >如一方欲变更联系方式或联系人，应提前以书面方式通知另一方。<br /><br />

                <b class="sec">九、 协议的生效、变更与终止</b><br /><br />
                &emsp;&emsp;<b class="no">9.1</b
                >本协议自用户点击"同意"并勾选"我已阅读并确认本协议，接受本协议项下所述全部条款"后生效；同时，用户使用"杰宜斯软件"的行为，亦构成其愿意接受本协议项下条款约束的行为。<br /><br />
                &emsp;&emsp;<b class="no">9.2</b
                >本协议一经签署，未经双方书面同意，任何一方不得随意更改本协议。其它双方在本协议签订之前达成的任何口头或未包含在本协议内的约定等，均不对双方发生约束力。如本协议在履行过程中有任何变更、补充或修改，双方应另行签订书面协议。<br /><br />
                &emsp;&emsp;<b class="no">9.3</b
                >除本协议和法律法规另有规定外，若用户未经杰宜斯科技书面同意单方提前解除或终止本协议的，用户已支付的软件服务费不予返还，且用户还应按照本协议约定软件服务费的百分之二十向杰宜斯科技支付违约金；若杰宜斯科技未经用户书面同意单方提前解除或终止本协议的，杰宜斯科技应向用户返还未履行期限对应的软件服务费，且杰宜斯科技还应按照本协议约定软件服务费的百分之二十向用户支付违约金。<br /><br />
                &emsp;&emsp;<b class="no">9.4</b>不可抗力。<br /><br />
                &emsp;&emsp;协议任何一方若因受到台风、海啸、火灾、洪水、地震、战争、通讯中断、交易所原因导致的故障或其他极端恶劣自然因素或其他不能预见、不能避免并不能克服等不可抗力影响，而不能或延迟履行本协议的（除当事人迟延履行后发生不可抗力外），受不可抗力影响一方应在不可抗力事件发生之日起五个工作日内及时书面通知另一方并提供相关证据予以证明。在不可抗力事由消除后，双方继续履行本协议，履行期限相应顺延。但若不可抗力发生超过30日，任何一方可解除或终止本协议且双方互不承担违约责任。<br /><br />
                &emsp;&emsp;<b class="no">9.5</b
                >杰宜斯科技保留随时更改或修改本协议条款和条件的权利，对于上述更改，杰宜斯科技将以软件公告形式告知用户，用户同意继续使用客户端的，视为对更改内容的认可与接受。<br /><br /><br /><br />
              </p>
            </div>
            <div class="agreement-check">
              <el-checkbox v-model="agreed" style="color: #525252"
                >已阅读并同意《软件服务协议》</el-checkbox
              >
            </div>
          </div>
          <div class="foot">
            <el-button
              class="indiv-btn"
              type="primary"
              :disabled="!agreed"
              :loading="submitting"
              @click="onAgree"
              size="small"
              style="width: 80px"
            >
              同意
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "PurchaseAgreementDialog",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      agreed: false,
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },

  watch: {
    visible(val) {
      if (!val) {
        this.agreed = false;
      }
    },
  },

  methods: {
    onClose() {
      if (this.submitting) {
        return;
      }
      this.dialogVisible = false;
      this.agreed = false;
      this.$emit("close");
    },

    onAgree() {
      if (!this.agreed || this.submitting) {
        return;
      }
      this.$emit("agree");
    },
  },
};
</script>

<style scoped>
.popContainer.indiv-pop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
}

.agreement-pop {
  position: relative;
  width: 800px;
  max-width: calc(100vw - 48px);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background: #fff;
}

.agreement-pop .hd {
  position: relative;
  z-index: 1;
  margin: 0;
  padding: 18px 20px;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #ebeef5;
  color: #000;
  line-height: 1.4;
}

.agreement-pop .body {
  position: relative;
  z-index: 1;
  padding: 20px 30px 0;
}

.agreement-pop .agreement-content {
  max-height: min(450px, calc(100vh - 280px));
  overflow-y: auto;
  padding: 16px 20px;
  color: #333;
  background: #f9fbff;
  border-radius: 2px;
  font-size: 14px;
  line-height: 1.6;
}

.agreement-pop .agreement-content p {
  margin: 0;
}

.agreement-pop .sec {
  font-size: 15px;
}

.agreement-pop .no {
  margin-right: 4px;
}

.agreement-pop .agreement-warn {
  color: #fb4044;
  text-decoration: underline;
}

.agreement-pop .agreement-check {
  margin-top: 16px;
}
.el-checkbox__label {
  font-weight: 500 !important;
}
.agreement-pop .foot {
  position: relative;
  z-index: 1;
  padding: 24px 30px 30px;
  text-align: center;
}

.agreement-pop .foot .indiv-btn.el-button.is-disabled,
.agreement-pop .foot .indiv-btn.el-button.is-disabled:hover,
.agreement-pop .foot .indiv-btn.el-button.is-disabled:focus {
  background-color: #5b85ff !important;
  border-color: #5b85ff !important;
  color: #fff !important;
  opacity: 0.65;
}
</style>



// WEBPACK FOOTER //
// src/view/user/purchaseService/PurchaseAgreementDialog.vue